import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { loadingSelector } from 'domain/env/envSelector';
import { companiesByIdSelector } from 'domain/companies';

import Container from '@mui/material/Container';
import LayoutPayCompany from 'components/mui/Layouts/PayCompany';
import PaymentsWorkspace from 'pages/dokkaPay/pages/company/components/PaymentsWorkspace';
import CircularProgressWithBackdrop from 'components/mui/CircularProgressWithBackdrop';
import CompanyPayNavigation from './components/CompanyPayNavigation';

const mapStateToProps = (state: unknown) => ({
  loading: loadingSelector(state),
  companies: companiesByIdSelector(state),
});

const PayCompanyPage: React.FC = () => {
  const { companyId } = useParams();
  const { loading, companies } = useSelector(mapStateToProps);
  const company = companies.get(companyId);

  return (
    <LayoutPayCompany DrawerContent={<CompanyPayNavigation />}>
      <CircularProgressWithBackdrop isOpen={loading} />
      <Container
        maxWidth={false}
        sx={{
          flexGrow: 1, // flexGrow: 1 - for ag-grid table
          px: '0px !important',
        }}
      >
        {!company ? null : <PaymentsWorkspace />}
      </Container>
    </LayoutPayCompany>
  );
};

export default PayCompanyPage;
